<script lang="ts">
	export let x: number,
		y: number,
		width: number,
		height: number,
		strokeWidth: number,
		position: 'rb' | 'lb' | 'rt' | 'lt' = 'rt',
		direction: 'forwards' | 'reverse' = 'forwards',
		color = 'primary',
		play = true,
		id: string = '';

	const scaleX = position.startsWith('l') ? -1 : 1,
		scaleY = position.endsWith('b') ? -1 : 1;

	width += strokeWidth;
	height -= strokeWidth;
	x = scaleX == -1 ? x + width : x;
	y = scaleY == -1 ? y + 190 : y;

	const d = `M0,0v${height}c0,40-10,35-30,35l-${width},0`;
</script>

<g {id} transform="translate({x + width} {y}) scale({scaleX} {scaleY})">
	<path
		id={`svg-energy-curve-${position}`}
		stroke-width={strokeWidth}
		stroke="white"
		fill="none"
		{d}
	/>
	{#if play}
		<path
			class="path-anime"
			stroke-width={strokeWidth - 1}
			stroke="var(--color-{color})"
			fill="none"
			{d}
			style="animation-direction: {direction}"
			stroke-dasharray="100 5"
			stroke-dashoffset="105"
		/>
		<!-- <circle r={strokeWidth / 2} fill="var(--color-{color})">
			<animateMotion repeatCount="indefinite" calcMode="linear" dur="5s" {begin}>
				<mpath xlink:href={`#svg-energy-curve-${position}`} />
			</animateMotion>
		</circle> -->
	{/if}
</g>

<style>
	.path-anime {
		animation: dash 0.75s linear infinite;
	}
	@keyframes dash {
		to {
			stroke-dashoffset: 0;
		}
	}
</style>
